import { ChartOfAccounts } from '../modules/accounting/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';

/// O plano é da empresa, não da unidade: gerenciar não depende da unidade escolhida (ADR 0061).
export function CompanyChartOfAccountsScreen() {
  const { can, company } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('accounting.chart.read')}>
      <ChartOfAccounts
        canManage={can('accounting.chart.manage')}
        salesContracted={company.moduleKeys.includes('sales')}
      />
    </GatedCompanyScreen>
  );
}
